<div class="modal-header">
  <div class="left">
    @if (icon) {
      <i class="icon" [class]="icon"></i>
    }

    <div class="title">
      <h2 class="h2-heading mb-0" [title]="header">{{ header }}</h2>
      <p class="sub-heading" [title]="subheader">{{ subheader }}</p>
    </div>
  </div>

  @if (!hideCloseButton) {
    <div class="right">
      <app-ag-action-icon-button iconClass="ic-close-20" (action)="onClose()"/>
    </div>
  }
</div>

<div class="modal-body">
  <form (ngSubmit)="onConfirm()">
    <ng-content></ng-content>
    <button type="submit" hidden></button>
  </form>
</div>

@if (isCustomFooter) {
  <ng-content select=".custom-footer"></ng-content>
} @else {
  <div class="modal-footer" [class]="footerClass">
    <div class="controls">
      @if (confirmText) {
        <app-button
          btnColor="orange"
          [loading]="isLoading"
          [isDisabled]="isLoading || isInvalid"
          [text]="confirmText"
          (clickBtn)="onConfirm()"
        />
      }

      <app-button
        btnColor="white"
        [isDisabled]="isLoading"
        [text]="closeText"
        (clickBtn)="onClose()"
      />
    </div>

    <ng-content select=".confirm-button"></ng-content>
  </div>
}
